import Flex from '@components/Flex/Flex';
import { FirstLabel, SecondLabel, StyledToggle } from './TwoLabelToggle.styles';
import { TwoLabelToggleProps } from './TwoLabelToggle.types';

const TwoLabelToggle: React.FC<TwoLabelToggleProps> = ({
  checked,
  labelProps,
  firstLabel,
  secondLabel,
  ...restProps
}) => {
  return (
    <Flex flex={1} alignItems='center'>
      <FirstLabel
        checked={!!checked}
        variant='body'
        fontWeight='fontWeightSemiBold'
        {...labelProps}
      >
        {firstLabel}
      </FirstLabel>
      <StyledToggle {...restProps} checked={checked} />
      <SecondLabel
        checked={!!checked}
        variant='body'
        fontWeight='fontWeightSemiBold'
        {...labelProps}
      >
        {secondLabel}
      </SecondLabel>
    </Flex>
  );
};

export default TwoLabelToggle;
